import styled, { ITheme } from '../../../theme'

const DateRangePickerWrapper = styled.div`
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    width: 100vw;
    padding: 10px;
    max-height: 568px;
    max-height: var(--full);
    border-radius: 0;
    box-shadow: unset;
    overflow: scroll;
  }
`

export default DateRangePickerWrapper
